export const updateClientWindowSize = (context, payload) => {
  context.commit("updateClientWindowSize", payload);
};

export const updateDark = (context, payload) => {
  context.commit("updateDark", payload);
};

export const updateMini = (context, payload) => {
  context.commit("updateMini", payload);
};

export const updateDeclinedPWA = (context, payload) => {
  context.commit("updateDeclinedPWA", payload);
};

export const updateInstalledPWA = (context, payload) => {
  context.commit("updateInstalledPWA", payload);
};

export const updateNetworkStatus = (context, payload) => {
  context.commit("updateNetworkStatus", payload);
};

export const notifyError = (context, error) => {
  const msg = error && (error.message || error.response || error.data) || "OOPS.. something went wrong";

  context.commit("addNotification", {
    text: msg,
    timeout: 5000,
  });
};


export const addActiveRequest = (context) => {
  const requests = context.state.activeRequests + 1;
  context.commit("updateActiveRequests", requests);
};
export const removeActiveRequest = (context) => {
  const requests = context.state.activeRequests > 1 ? context.state.activeRequests - 1 : 0;
  context.commit("updateActiveRequests", requests);
};